export default __webpack_public_path__ + "static/media/Jasmin.36137e75.png";